
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import DashboardLayout from "layouts/LayoutContainers/DashboardLayout";
import DashboardNavbar from "layouts/Navbars/DashboardNavbar";
import Footer from "layouts/Footer";
import Config from "../../config.js";
import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from 'react-toastify';
import { useForm, Controller } from 'react-hook-form';
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import { Select, MenuItem, FormControl } from '@mui/material';
import { Backdrop, CircularProgress } from '@mui/material';
import "rsuite/dist/rsuite.min.css";
import { useTranslation } from "react-i18next";
import { useNavigate } from 'react-router-dom';
import { handleErrors, checkPrivilege } from "common.js";
import { PRIVILEGE } from "constants.js";
import MDTypography from "components/MDTypography";
import { Radio, RadioGroup, FormControlLabel } from "@mui/material";

function ViewSettings() {

  const navigate = useNavigate();
  const { t } = useTranslation();
  const BASE = Config.BASE;
  const TOKEN = window.localStorage.getItem('token');
  const [settingsData, setData] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const adminType = localStorage.getItem("type");
  const { register, handleSubmit, setValue, getValues, setError, formState: { errors }, control } = useForm();
  const [enableAdminLog, setEnableAdminLog] = useState(true);
  const [enableVendorLog, setEnableVendorLog] = useState(true);

  const [carrierServiceId, setCarrierServiceId] = useState('');
  const [carrierService, setCarrierService] = useState(false);
  const [loading, setLoading] = useState(false);

  const data = () => {
    setIsLoading(true);
    axios({
      // Endpoint to send files
      url: BASE + "api/configuration/viewSettings",
      method: "GET",
      headers: {
        // Add any auth token here
        Authorization: `Bearer ${TOKEN}`,
        function: Config.FUNCTION_KEY
      },
      // Attaching the form data
    }).then(function (response) {
      setIsLoading(false);
      if (response.status == 200) {
        const status = response.data.status;
        const message = response.data.message;
        if (status == 1) {
          setData(response.data),
            setValueFn(response.data.data)
        }
        else {
          toast.error(t(message))
        }
      }
      else {
        toast.error(t('unableToProccessRequest'));
      }
    })
      .catch(function (error) {
        setIsLoading(false);
        handleErrors(error, t, navigate);
      });
  }

  useEffect(() => {
    data();
  }, []);

  const setValueFn = (setValueData) => {
    setValue('minPasswordLength', setValueData.minPasswordLength);
    setValue('senderName', setValueData.senderName);
    setValue('senderEmail', setValueData.senderEmail);
    setValue('smtpPassword', setValueData.smtpPassword);
    setValue('smtpHost', setValueData.smtpHost);
    setValue('smtpUser', setValueData.smtpUser);
    setValue('smtpPort', setValueData.smtpPort);
    setValue('locale', setValueData.locale);
    setValue('jwtExpiryHour', setValueData.jwtExpiryHour);
    setValue('forgotPassExpiryHour', setValueData.forgotPassExpiryHour);
    setValue('adminFrontEndUrl', setValueData.adminFrontEndUrl);
    setValue('vendorFrontEndUrl', setValueData.vendorFrontEndUrl);
    setValue('defaultVendorPaymentMode', setValueData.defaultVendorPaymentMode);
    setValue('appName', setValueData.appName);
    setValue('paginationSize', setValueData.paginationSize);
    setValue('termsAndConditions', setValueData.termsAndConditions);
    setValue('shopName', setValueData.shopName);
    setValue('shopifyAccessToken', setValueData.shopifyAccessToken);
    setValue('webhookSecretKey', setValueData.webhookSecretKey);
    setValue('delhiVeryApiEndPoint', setValueData.delhiVeryApiEndPoint);
    setValue('delhiVeryApiToken', setValueData.delhiVeryApiToken);
    setValue('returnDays', setValueData.returnDays);
    setValue('externalApiKey', setValueData.externalApiKey);
    setValue('adminCommissionPercentage', setValueData.adminCommissionPercentage);
    setValue('discountPriceBearer', setValueData.discountPriceBearer);
    setValue('shippingPriceBearer', setValueData.shippingPriceBearer);
    setValue('fbAppId', setValueData.fbAppId);
    setValue('googleAppId', setValueData.googleAppId);
    setValue('azureConnectionString', setValueData.azureConnectionString);
    setValue('azureContainerName', setValueData.azureContainerName);
    setValue('azureAccountName', setValueData.azureAccountName);
    setValue('azureAccessKey', setValueData.azureAccessKey);
    setValue('hsncodeJson', setValueData.hsncodeJson);
    setValue('shopLocationId', setValueData.shopLocationId);

    setValue('enableAdminLog', setValueData.enableAdminLog);
    setEnableAdminLog(setValueData.enableAdminLog == 1 ? true : false);
    setValue('enableVendorLog', setValueData.enableVendorLog);
    setEnableVendorLog(setValueData.enableVendorLog == 1 ? true : false);
    setValue('vendorApiAccessToken', setValueData.vendorApiAccessToken);
    setValue('vendorBackendEndpoint', setValueData.vendorBackendEndpoint);

    setValue('carrierSeviceId', setValueData.carrierSeviceId);
    setCarrierServiceId(setValueData.carrierSeviceId);
    setCarrierService(setValueData.carrierSeviceId ? true : false);
  }

  const handleCarrierService = () => {
    let data = {};
    if (carrierService) {
      data = { 'enabled': 0, id: carrierServiceId }
    }
    else
      data = { 'enabled': 1 }
    setLoading(true);
    axios.post(BASE + 'api/configuration/carrier-service-status', data, {
      headers: {
        Authorization: `Bearer ${TOKEN}`,
        function: Config.FUNCTION_KEY,
      }
    })
      .then((response) => {
        setLoading(false);
        if (response.status == 200) {
          const status = response.data.status;
          const message = response.data.message;
          if (status == 1) {
            if (response.data.carrierServiceId && response.data.carrierServiceId != '') {
              setCarrierServiceId(response.data.carrierServiceId);
              setCarrierService(!carrierService);
            }
            else {
              setCarrierServiceId('');
              setCarrierService(!carrierService);
            }
            toast.success(t(message));
          }
          else
            toast.error(t(message));
        }
        else {
          toast.error(t('unableToProccessRequest'));
        }
      })
      .catch(error => {
        setLoading(false);
        handleErrors(error, t, navigate);
      });
  };

  const handleChangeAdmin = () => {
    let value = enableAdminLog;
    setEnableAdminLog((prevValue) => !prevValue);
    setValue('enableAdminLog', value == 1 ? 2 : 1);
  };

  const handleChangeVendor = () => {
    let value = enableVendorLog
    setEnableVendorLog((prevValue) => !prevValue);
    setValue('enableVendorLog', value == 1 ? 2 : 1)
  };

  const onSubmit = async (data) => {
    setIsLoading(true);
    axios({
      // Endpoint to send files
      url: BASE + "api/configuration/editSettings",
      method: "POST",
      data: data,
      headers: {
        // Add any auth token here
        Authorization: `Bearer ${TOKEN}`,
        function: Config.FUNCTION_KEY
      },
      // Attaching the form data
    }).then(function (response) {
      setIsLoading(false);
      if (response.status == 200) {
        const status = response.data.status;
        const message = response.data.message;
        if (status == 1) {
          toast.success(t(message))
        }
        else {
          if (message)
            toast.error(t(message))
          if (response.data.errors.length > 0)
            response.data.errors.forEach((error) => {
              setError(error.field, {
                type: 'server',
                message: error.errors[0]
              });
            })
        }
      }
      else {
        toast.error(t('unableToProccessRequest'));
      }
    }).catch(function (error) {
      setIsLoading(false);
      handleErrors(error, t, navigate);
    });
  };

  const GeneralSettings = () => {

    return (
      <Card>
        <MDBox px={2} pt={2} pb={2}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12}>
              <MDTypography variant="h6" className="uppercaseLetters" >{t('generalSettings')}</MDTypography>
            </Grid>
            <Grid item xs={12} sm={4} md={4}>
              <MDTypography className="labelStyle">{t('app name')}</MDTypography>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <MDInput type="text" name="appName"  {...register("appName")} fullWidth />
            </Grid>
            <Grid item xs={12} sm={4} md={4}>
              <MDTypography className="labelStyle">{t('locale')}</MDTypography>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <MDInput type="text" name="locale"  {...register("locale")} fullWidth />
            </Grid>
            <Grid item xs={12} sm={4} md={4}>
              <MDTypography className="labelStyle">{t('admin front end url')}</MDTypography>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <MDInput type="text" name="adminFrontEndUrl"  {...register("adminFrontEndUrl")} fullWidth />
            </Grid>
            <Grid item xs={12} sm={4} md={4}>
              <MDTypography className="labelStyle">{t('vendor front end url')}</MDTypography>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <MDInput type="text" name="vendorFrontEndUrl"  {...register("vendorFrontEndUrl")} fullWidth />
            </Grid>
            <Grid item xs={12} sm={4} md={4}>
              <MDTypography className="labelStyle">{t('pagination size')}</MDTypography>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <MDInput type="number" InputProps={{ inputProps: { min: 0 } }} name="paginationSize"  {...register("paginationSize")} fullWidth />
            </Grid>
            <Grid item xs={12} sm={4} md={4}>
              <MDTypography className="labelStyle">{t('terms and condition')}</MDTypography>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <MDInput multiline rows={5} type="text" name="termsAndConditions"  {...register("termsAndConditions")} fullWidth />
            </Grid>
            <Grid item xs={12} sm={4} md={4}>
              <MDTypography className="labelStyle">{t('hsncodeJson')}</MDTypography>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <MDInput multiline rows={5} type="text" name="hsncodeJson"  {...register("hsncodeJson")} fullWidth />
              <MDTypography className="infoStyle" component="span" variant="body2" color="info">{t('hsnCodeJsonFormat')}</MDTypography>
            </Grid>
            <Grid item xs={12} sm={4} md={4}>
              <MDTypography className="labelStyle">{t('return days')}</MDTypography>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <MDInput type="text" name="returnDays"  {...register("returnDays")} fullWidth />
            </Grid>
            <Grid item xs={12} sm={4} md={4}>
              <MDTypography className="labelStyle">{t('external api key')}</MDTypography>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <MDInput type="text" name="externalApiKey"  {...register("externalApiKey")} fullWidth />
            </Grid>
          </Grid>
        </MDBox>
      </Card>
    )
  }

  const EmailSettings = () => {

    return (
      <Card>
        <MDBox px={2} pt={2} pb={2}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12}>
              <MDTypography variant="h6" className="uppercaseLetters" >{t('emailSettings')}</MDTypography>
            </Grid>
            <Grid item xs={12} sm={4} md={4}>
              <MDTypography className="labelStyle">{t('sender name')}</MDTypography>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <MDInput type="text" name="senderName"  {...register("senderName", { required: true })} fullWidth />
            </Grid>
            <Grid item xs={12} sm={4} md={4}>
              <MDTypography className="labelStyle">{t('sender email')}</MDTypography>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <MDInput type="text" name="senderEmail"  {...register("senderEmail", { pattern: /^[^@ ]+@[^@ ]+\.[^@ .]{2,}$/ })} fullWidth />
            </Grid>
            <Grid item xs={12} sm={4} md={4}>
              <MDTypography className="labelStyle">{t('SMTP host')}</MDTypography>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <MDInput type="text" name="smtpHost"  {...register("smtpHost")} fullWidth />
            </Grid>
            <Grid item xs={12} sm={4} md={4}>
              <MDTypography className="labelStyle">{t('SMTP port')}</MDTypography>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <MDInput type="text" name="smtpPort"  {...register("smtpPort")} fullWidth />
            </Grid>
            <Grid item xs={12} sm={4} md={4}>
              <MDTypography className="labelStyle">{t('SMTP user')}</MDTypography>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <MDInput type="text" name="smtpUser"  {...register("smtpUser")} fullWidth />
            </Grid>
            <Grid item xs={12} sm={4} md={4}>
              <MDTypography className="labelStyle">{t('SMTP password')}</MDTypography>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <MDInput type="text" name="smtpPassword"  {...register("smtpPassword")} fullWidth />
            </Grid>
          </Grid>
        </MDBox>
      </Card>

    )
  }

  const VendorRegistrationSettings = () => {
    return (
      <Card>
        <MDBox px={2} pt={2} pb={2}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12}>
              <MDTypography variant="h6" className="uppercaseLetters" >{t('vendorRegistrationSettings')}</MDTypography>
            </Grid>
            <Grid item xs={12} sm={4} md={4}>
              <MDTypography className="labelStyle">{t('fbAppId')}</MDTypography>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <MDInput type="text" name="fbAppId"  {...register("fbAppId")} fullWidth />
            </Grid>
            <Grid item xs={12} sm={4} md={4}>
              <MDTypography className="labelStyle">{t('googleAppId')}</MDTypography>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <MDInput type="text" name="googleAppId"  {...register("googleAppId")} fullWidth />
            </Grid>
            <Grid item xs={12} sm={4} md={4}>
              <MDTypography className="labelStyle">{t('minimum password length')}</MDTypography>
            </Grid>
            <Grid item xs={6} sm={6} md={6}>
              <MDInput type="number" InputProps={{ inputProps: { min: 0 } }} name="minPasswordLength"  {...register("minPasswordLength", { required: true })} fullWidth />
            </Grid>
            <Grid item xs={12} sm={4} md={4}>
              <MDTypography className="labelStyle">{t('JWT token expiry')}</MDTypography>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <MDInput type="number" InputProps={{ inputProps: { min: 0 } }} name="jwtExpiryHour"  {...register("jwtExpiryHour")} fullWidth />
            </Grid>
            <Grid item xs={12} sm={4} md={4}>
              <MDTypography className="labelStyle">{t('forgot password expiry')}</MDTypography>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <MDInput type="number" InputProps={{ inputProps: { min: 0 } }} name="forgotPassExpiryHour"  {...register("forgotPassExpiryHour")} fullWidth />
            </Grid>
          </Grid>
        </MDBox>
      </Card>
    )
  }

  const VendorPaymentSettings = () => {
    return (
      <Card>
        <MDBox px={2} pt={2} pb={2}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12}>
              <MDTypography variant="h6" className="uppercaseLetters" >{t('vendorPaymentSettings')}</MDTypography>
            </Grid>
            <Grid item xs={12} sm={4} md={4}>
              <MDTypography className="labelStyle">{t('default vendor payment mode')}</MDTypography>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <MDInput
                select
                name="defaultVendorPaymentMode"
                InputProps={{
                  classes: { root: "select-input-styles" },
                }}
                value={settingsData.data.defaultVendorPaymentMode}
                onChange={
                  (obj) => {
                    setData((pre) => {

                      for (const key in pre.data) {
                        if (pre.data.hasOwnProperty(key)) {
                          if (key == "defaultVendorPaymentMode") {
                            let newData = pre.data.defaultVendorPaymentMode = obj.target.value;
                            return { ...pre, newData };
                          }
                        }
                      }
                    });
                    setValue('defaultVendorPaymentMode', obj.target.value);
                  }
                } fullWidth
              >
                <MenuItem value={1}>{t('Bank')}</MenuItem>
                <MenuItem value={2}>{t('UPI')}</MenuItem>
              </MDInput>
            </Grid>
            <Grid item xs={12} sm={4} md={4}>
              <MDTypography className="labelStyle">{t('adminCommissionPercentage')}</MDTypography>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <MDInput type="text" name="adminCommissionPercentage"  {...register("adminCommissionPercentage")} fullWidth />
            </Grid>
            <Grid item xs={12} sm={4} md={4}>
              <MDTypography className="labelStyle">{t('discountPriceBearer')}</MDTypography>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <Controller
                name="discountPriceBearer"
                control={control}
                defaultValue={1}
                render={({ field }) => (
                  <MDInput
                    select
                    {...field}
                    fullWidth
                    InputProps={{
                      classes: { root: "select-input-styles select-padding-0" },
                    }}
                  >
                    <MenuItem key={1} value={1}> {t("admin")}</MenuItem>
                    <MenuItem key={2} value={2}> {t("vendor")}</MenuItem>
                  </MDInput>
                )}
              />
            </Grid>
            <Grid item xs={12} sm={4} md={4}>
              <MDTypography className="labelStyle">{t('shippingPriceBearer')}</MDTypography>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <Controller
                name="shippingPriceBearer"
                control={control}
                defaultValue={1}
                render={({ field }) => (
                  <MDInput
                    select
                    {...field}
                    fullWidth
                    InputProps={{
                      classes: { root: "select-input-styles select-padding-0" },
                    }}
                  >
                    <MenuItem key={1} value={1}> {t("admin")}</MenuItem>
                    <MenuItem key={2} value={2}> {t("vendor")}</MenuItem>
                  </MDInput>
                )}
              />
            </Grid>
          </Grid>
        </MDBox>
      </Card>
    )
  }

  const ShopifySettings = () => {
    return (
      <Card>
        <MDBox px={2} pt={2} pb={2}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12}>
              <MDTypography variant="h6" className="uppercaseLetters" >{t('shopifySettings')}</MDTypography>
            </Grid>
            <Grid item xs={12} sm={4} md={4}>
              <MDTypography className="labelStyle">{t('shopifyShopDomain')}</MDTypography>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <MDInput type="text" name="shopName"  {...register("shopName")} fullWidth />
              <MDTypography className="infoStyle" component="span" variant="body2" color="info">{t('shopifyShopDomainNote')}</MDTypography>
            </Grid>
            <Grid item xs={12} sm={4} md={4}>
              <MDTypography className="labelStyle">{t('shopify Access Token')}</MDTypography>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <MDInput type="text" name="shopifyAccessToken"  {...register("shopifyAccessToken")} fullWidth />
            </Grid>
            <Grid item xs={12} sm={4} md={4}>
              <MDTypography className="labelStyle">{t('webhook secret key')}</MDTypography>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <MDInput type="text" name="webhookSecretKey"  {...register("webhookSecretKey")} fullWidth />
            </Grid>
            <Grid item xs={12} sm={4} md={4}>
              <MDTypography className="labelStyle">{t('shopLocationId')}</MDTypography>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <MDInput type="text" name="shopLocationId"  {...register("shopLocationId")} fullWidth />
            </Grid>
          </Grid>
        </MDBox>
      </Card>
    )
  }

  const CarrierServiceSettings = () => {
    return (
      <Card>
        <MDBox px={2} pt={2} pb={2}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12}>
              <MDTypography variant="h6" className="uppercaseLetters" >{t('carrierServiceSettings')}</MDTypography>
            </Grid>
            <Grid item xs={12} sm={4} md={4}>
              <MDTypography className="labelStyle">{t('delhivery api end point')}</MDTypography>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <MDInput type="text" name="delhiVeryApiEndPoint"  {...register("delhiVeryApiEndPoint")} fullWidth />
            </Grid>
            <Grid item xs={12} sm={4} md={4}>
              <MDTypography className="labelStyle">{t('delhivery api token')}</MDTypography>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <MDInput type="text" name="delhiVeryApiToken"  {...register("delhiVeryApiToken")} fullWidth />
            </Grid>
            {(adminType == PRIVILEGE.ADMIN || (adminType == PRIVILEGE.SUBADMIN && checkPrivilege("configuration", "read"))) ?
              <>
                <Grid item xs={12} sm={4} md={4}>
                  <MDTypography className="labelStyle">{t('delhiveryShopifyStatus')}</MDTypography>
                </Grid>
                <Grid item xs={12} sm={6} md={6}>
                  {loading ?
                    <CircularProgress className="carrierServiceLoading" />
                    :
                    <RadioGroup
                      aria-labelledby="carrierService"
                      value={carrierService}
                      name="carrierService"
                      onChange={(e) => {
                        handleCarrierService();
                      }}
                      row
                    >
                      <FormControlLabel className="radioButtonIcon" value={true} control={<Radio />} label={t("enable")}
                        disabled={adminType == PRIVILEGE.SUBADMIN ? checkPrivilege("configuration", "write") ? false : true : false} />
                      <FormControlLabel className="radioButtonIcon" value={false} control={<Radio />} label={t("disable")}
                        disabled={adminType == PRIVILEGE.SUBADMIN ? checkPrivilege("configuration", "write") ? false : true : false} />
                    </RadioGroup>
                  }
                </Grid>
              </>
              : null
            }
          </Grid>
        </MDBox>
      </Card>
    )
  }

  const AzureSettings = () => {
    return (
      <Card>
        <MDBox px={2} pt={2} pb={2}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12}>
              <MDTypography variant="h6" className="uppercaseLetters" >{t('azureStorageSettings')}</MDTypography>
            </Grid>
            <Grid item xs={12} sm={4} md={4}>
              <MDTypography className="labelStyle">{t('azureConnectionString')}</MDTypography>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <MDInput type="text" name="azureConnectionString"  {...register("azureConnectionString")} fullWidth />
            </Grid>

            <Grid item xs={12} sm={4} md={4}>
              <MDTypography className="labelStyle">{t('azureContainerName')}</MDTypography>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <MDInput type="text" name="azureContainerName"  {...register("azureContainerName")} fullWidth />
            </Grid>

            <Grid item xs={12} sm={4} md={4}>
              <MDTypography className="labelStyle">{t('azureAccountName')}</MDTypography>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <MDInput type="text" name="azureAccountName"  {...register("azureAccountName")} fullWidth />
            </Grid>
            <Grid item xs={12} sm={4} md={4}>
              <MDTypography className="labelStyle">{t('azureAccessKey')}</MDTypography>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <MDInput type="text" name="azureAccessKey"  {...register("azureAccessKey")} fullWidth />
            </Grid>
          </Grid>
        </MDBox>
      </Card>

    )

  }

  const LogSettings = () => {
    return (
      <Card>
        <MDBox px={2} pt={2} pb={2} >
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12}>
              <MDTypography variant="h6" className="uppercaseLetters" >{t('logSettings')}</MDTypography>
            </Grid>
            <Grid item xs={12} sm={4} md={4}>
              <MDTypography className="labelStyle">{t('enableAdminLog')}</MDTypography>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <RadioGroup
                aria-labelledby="enableAdminLog"
                value={enableAdminLog}
                name="enableAdminLog"
                onChange={(e) => {
                  handleChangeAdmin();
                }}
                row
              >
                <FormControlLabel className="radioButtonIcon" value={true} control={<Radio />} label={t("enable")} />
                <FormControlLabel className="radioButtonIcon" value={false} control={<Radio />} label={t("disable")} />
              </RadioGroup>
            </Grid>
            <Grid item xs={12} sm={4} md={4}>
              <MDTypography className="labelStyle">{t('enableVendorLog')}</MDTypography>
            </Grid>

            <Grid item xs={12} sm={6} md={6}>
              <RadioGroup
                aria-labelledby="enableVendorLog"
                value={enableVendorLog}
                name="enableVendorLog"
                onChange={(e) => {
                  handleChangeVendor();
                }}
                row
              >
                <FormControlLabel className="radioButtonIcon" value={true} control={<Radio />} label={t("enable")} />
                <FormControlLabel className="radioButtonIcon" value={false} control={<Radio />} label={t("disable")} />
              </RadioGroup>
            </Grid>
            <Grid item xs={12} sm={4} md={4}>
              <MDTypography className="labelStyle">{t('vendorLogEndpoint')}</MDTypography>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <MDInput type="text" name="vendorBackendEndpoint"  {...register("vendorBackendEndpoint")} fullWidth />
            </Grid>
            <Grid item xs={12} sm={4} md={4}>
              <MDTypography className="labelStyle">{t('vendorLogAccessToken')}</MDTypography>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <MDInput type="text" name="vendorApiAccessToken"  {...register("vendorApiAccessToken")} fullWidth />
            </Grid>
          </Grid>
        </MDBox>
      </Card>
    )
  }

  return (
    <DashboardLayout>
      <DashboardNavbar pageTitle={t("admin settings")} />
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={isLoading}>
        <CircularProgress color="inherit" />
      </Backdrop>

      {(Object.keys(settingsData).length > 0) ?
        <MDBox component="form" role="form" onSubmit={handleSubmit(onSubmit)}>
          <MDBox pt={2} ><GeneralSettings /></MDBox>
          <MDBox pt={2} ><EmailSettings /></MDBox>
          <MDBox pt={2} ><VendorRegistrationSettings /></MDBox>
          <MDBox pt={2} ><VendorPaymentSettings /> </MDBox>
          <MDBox pt={2} ><ShopifySettings /></MDBox>
          <MDBox pt={2} ><CarrierServiceSettings /></MDBox>
          <MDBox pt={2} ><AzureSettings /></MDBox>
          <MDBox pt={2} ><LogSettings /></MDBox>
          <MDBox pt={2} >
            <Grid container spacing={2} mt={2} >
              <Grid item xs={12} sm={4} md={4}>
              </Grid>
              <Grid item xs={12} sm={6} md={6}>
                {(adminType == PRIVILEGE.ADMIN || (adminType == PRIVILEGE.SUBADMIN && checkPrivilege("configuration", "write"))) ?
                  <MDButton type="submit" variant="gradient" color="info" className="edit-button-mb" disableRipple>{t('update')}</MDButton>
                  : null
                }
              </Grid>
            </Grid>
          </MDBox>
        </MDBox>
        :
        null
      }
    </DashboardLayout>
  );
}

export default ViewSettings;
